import React, { useEffect, useState } from 'react';
import { Paragraph } from '../Paragraph/Paragraph';
import { TimeRemaining, updateRemainingTime, fontSizes } from '../../helpers/tileHelper';

export interface CountdownProps {
  className?: string;
  openingTime: string;
  closedText?: string;
  openingTimeLabel?: string;
  textStyle?: string;
  paragraphSize?: keyof typeof fontSizes;
}

export const CountDown = ({ openingTime, className = '', closedText = 'Bordet er desværre lukket', openingTimeLabel = 'Bord åbner om', textStyle = '', paragraphSize = 12 }: CountdownProps) => {
  const [timeRemaining, setTimeRemaining] = useState<TimeRemaining | 'closed' | null>(null);
  const isClosed = timeRemaining === 'closed' || !timeRemaining;

  useEffect(() => {
    setTimeRemaining(updateRemainingTime(openingTime));
    const interval = setInterval(() => setTimeRemaining(updateRemainingTime(openingTime)), 1000);

    return () => clearInterval(interval);
  }, [openingTime]);

  const ariaLabel = isClosed ? closedText : `${openingTimeLabel} ${timeRemaining?.hours > 0 ? `${timeRemaining?.hours} timer og ` : ''} ${timeRemaining?.minutes} minutter`;

  return (
    <div
      className={`text-center ${className}`}
      aria-label={ariaLabel}>
      <Paragraph
        size={paragraphSize}
        truncate={isClosed ? 3 : 0}
        weight='bold'
        className={isClosed ? `m-auto max-w-[16ch] ${textStyle}` : ''}
      >{isClosed ? closedText : openingTimeLabel}</Paragraph>

      {!isClosed && <div className='flex items-center justify-center font-bold'>
        <span>
          {String(timeRemaining?.hours)?.padStart(2, '0')}
        </span>
        <span className='px-1 font-serif font-normal text-neutrals-coolGrey-400 text-18'>|</span>
        <span>
          {String(timeRemaining?.minutes)?.padStart(2, '0')}
        </span>
        <span className='px-1 font-serif font-normal text-neutrals-coolGrey-400 text-18'>|</span>
        <span>
          {String(timeRemaining?.seconds)?.padStart(2, '0')}
        </span>
      </div>}
    </div>
  );
};
